/**
 * Contentful image utilities for homepage V2 components
 */

const CONTENTFUL_BASE_URL = "https://images.ctfassets.net/jg6lo9a2ukvr";

/**
 * Build a Contentful image URL with the base URL and optional format
 * @param assetId - The Contentful asset ID
 * @param format - Image format (webp, jpg, png, etc.) - defaults to webp
 * @param quality - Image quality (1-100) - defaults to 75
 * @returns Complete Contentful image URL
 */
export function buildContentfulImageUrl(
  assetId: string,
  format = "webp",
  quality = 75
): string {
  if (!assetId) {
    throw new Error("Asset ID is required");
  }

  return `${CONTENTFUL_BASE_URL}/${assetId}?fm=${format}&q=${quality}`;
}

/**
 * Build multiple Contentful image URLs for responsive design
 * @param assetIds - Object containing asset IDs for different breakpoints
 * @param format - Image format (webp, jpg, png, etc.) - defaults to webp
 * @returns Object with complete Contentful image URLs
 */
export function buildResponsiveContentfulUrls(
  assetIds: {
    desktop?: string;
    tablet?: string;
    mobile?: string;
    desktopBg?: string;
    tabletBg?: string;
    mobileBg?: string;
  },
  format = "webp"
) {
  const urls: {
    desktop?: string;
    tablet?: string;
    mobile?: string;
    desktopBg?: string;
    tabletBg?: string;
    mobileBg?: string;
  } = {};

  Object.entries(assetIds).forEach(([key, assetId]) => {
    if (assetId) {
      urls[key as keyof typeof urls] = buildContentfulImageUrl(assetId, format);
    }
  });

  return urls;
}
